import React from "react";

import ScreenLayout from "@/Components/Layouts/Native/ScreenLayout";
import { type AppUserSession } from "@/schemas/auth/session";
import UpdatePasswordForm from "@/screens/Settings/Security/Components/UpdatePasswordForm";

type UpdatePasswordScreenProps = {
  session: AppUserSession;
};

function UpdatePasswordScreen({
  session,
}: UpdatePasswordScreenProps): React.JSX.Element {
  return (
    <ScreenLayout isLoading={false}>
      <UpdatePasswordForm session={session} />
    </ScreenLayout>
  );
}

export default UpdatePasswordScreen;
